import { Controller } from "stimulus";
import Rails from "rails-ujs";


export default class extends Controller {
  static targets = [];
  
  connect() {
    window.dispatchEvent(new CustomEvent("applied-new-discount-code"));
  }


  disconnect() {
    window.dispatchEvent(new CustomEvent("removed-discount-code"));
  }
  
}
